export const PICTURE_CORNERS = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
];
export const CORNER_AUTHORITY = [
    {
        kind: "screen-state",
        corner: "top-right",
        why: "The honesty signal — it says this picture may be stale. Nothing " +
            "branded may outrank the admission that the branding itself could be " +
            "out of date, so this one is never displaced by anything. MOVED from " +
            "bottom-right to top-right on 2026-09-27 (Sigge) to free that corner " +
            "for `supplier-logo`: it reads as a status LED either way, and it kept " +
            "rank 1 rather than yielding, because being displaced is the one thing " +
            "it must never be.",
    },
    {
        kind: "channel-logo",
        corner: "bottom-left",
        why: "The identity of what is PLAYING, contractual for a curated effect " +
            "channel, and the only mark here a guest can use to know what they are " +
            "watching.",
    },
    {
        kind: "supplier-logo",
        corner: "bottom-right",
        why: "The mark of whoever supplied the item PLAYING right now, on a signage " +
            "loop (`CONTENT-26`, ruled 2026-09-27 by Sigge: lower right). It sits " +
            "opposite `channel-logo` rather than fighting it, because on an effect " +
            "channel carrying a catalogue title BOTH are true at once - the channel " +
            "is what the wall is showing, the supplier is whose film is on it. " +
            "Source is the PLAYING ASSET's catalogue `logo` image, not " +
            "`ContentOwner.brand.logoUrl` - see the note in SURFACE_CLAIMANTS.",
    },
    {
        kind: "supplier-credit",
        corner: "bottom-left",
        why: "The identity of whoever supplied ONE item inside it. It loses the " +
            "corner to the channel it is playing inside, and losing costs nothing " +
            "it cannot afford: it already has an honest home in the text column of " +
            "the VOD detail screen (`CONTENT-26`, commit 410a98d). If a licence ever " +
            "OBLIGES a per-item logo on the picture, the answer is to move this entry " +
            "above `channel-logo` here - one reviewable line with a written reason - " +
            "and never to stack it at a call site.",
    },
    {
        kind: "premise-mark",
        corner: "top-left",
        why: "The operator's own house mark. Discretionary — nobody's licence " +
            "requires it — so it yields to anything contractual.",
    },
    {
        kind: "affordance",
        corner: "top-right",
        why: "Foyer's own furniture: a clock, a key hint, a QR. Ours to move, so it " +
            "is the one that moves.",
    },
];
const RULES = Object.freeze(Object.fromEntries(CORNER_AUTHORITY.map((r) => [r.kind, r])));
const RANKS = Object.freeze(Object.fromEntries(CORNER_AUTHORITY.map((r, i) => [r.kind, i + 1])));
export function rankOf(kind) {
    return RANKS[kind];
}
export function ruleFor(kind) {
    return RULES[kind];
}
export const SURFACE_CLAIMANTS = Object.freeze({
    signage: ["screen-state", "channel-logo", "supplier-logo", "supplier-credit"],
    scheme: ["screen-state"],
    "door-sign": ["screen-state"],
});
export function resolveCorners(claimants) {
    const byRank = [...new Set(claimants)].sort((a, b) => rankOf(a) - rankOf(b));
    const held = new Map();
    const granted = [];
    const denied = [];
    for (const kind of byRank) {
        const { corner } = RULES[kind];
        const holder = held.get(corner);
        if (holder) {
            denied.push({ kind, wanted: corner, heldBy: holder });
            continue;
        }
        held.set(corner, kind);
        granted.push({ kind, corner, rank: rankOf(kind) });
    }
    return { granted, denied };
}
const RESOLVED = Object.freeze(Object.fromEntries(Object.keys(SURFACE_CLAIMANTS).map((s) => [
    s,
    resolveCorners(SURFACE_CLAIMANTS[s]),
])));
export function surfaceCorners(surface) {
    return RESOLVED[surface];
}
export function cornerFor(surface, kind) {
    var _a, _b;
    return (_b = (_a = RESOLVED[surface].granted.find((g) => g.kind === kind)) === null || _a === void 0 ? void 0 : _a.corner) !== null && _b !== void 0 ? _b : null;
}
export function denialFor(surface, kind) {
    var _a;
    return (_a = RESOLVED[surface].denied.find((d) => d.kind === kind)) !== null && _a !== void 0 ? _a : null;
}
export function cornerEdges(corner) {
    return {
        x: corner.endsWith("-left") ? "left" : "right",
        y: corner.startsWith("top-") ? "top" : "bottom",
    };
}
